import team from './team.de.ts'
import unit from './unit.de.ts'
import common from 'plugins/i18n/common.de.ts'
import building from './building.de.ts'
import reportStatusDe from 'plugins/i18n/entity/reportStatus.de.ts'

const report = {
	name: 'Meldung | Meldungen',
	icon: 'fas fa-ticket',
	fields: {
		id: common.id,
		report_status: {
			name: 'Status',
			...reportStatusDe.fields,
		},
		assigned_team: {
			...team.fields,
		},
		author: 'Melder',
		type: 'Typ',
		location: 'Standort',
		building: {
			name: building.name,
			...building.fields,
		},
		unit: {
			name: unit.name,
			...unit.fields,
		},
		created: common.createdAt,
	},
}

export default report
